export default __webpack_public_path__ + "static/media/flipped_classroom.dc47ebf7.png";